import { render, staticRenderFns } from "./judge.vue?vue&type=template&id=ab09cb78&scoped=true"
import script from "./judge.vue?vue&type=script&lang=js"
export * from "./judge.vue?vue&type=script&lang=js"
import style0 from "./judge.vue?vue&type=style&index=0&id=ab09cb78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab09cb78",
  null
  
)

export default component.exports